'use client';

import { c as _c } from "react/compiler-runtime";
import { SvgChevronright, SvgWarningFill } from '@common/icon';
import { cn } from '@core/utils';
import type { GiftProductDetail } from '@/api/getGiftProductDetail';
import { CustomLink } from '@/app/_components/CustomLink';
import { Rating } from '@/app/donation/_components/Rating';
import { ShareButton } from '@/app/donation/_components/ShareButton';
import { calculateRequiredDonationAmount } from '@/app/donation/_utils/giftOrder';
import { GIFT_SALE_STATUS } from '@/app/donation/constants';
import type { GiftSaleStatus } from '@/app/donation/types';
import { Image } from '@/components/client';
import { DONATION_ROUTES } from '@/constants';
import { BREAKPOINTS } from '@/constants/breakpoints';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { useScrollToSection } from '@/hooks/useScrollToSection';
import { useGiftOption } from '../../../_context/GiftOptionContext';
import { DELIVERY_PERIOD_LABEL } from '../../../constants';
import { PriceInfo } from '../../GiftDetailHeader/_components/PriceInfo';
import { PrefillForm } from '../PrefillForm';
import { DesktopMainImages } from './DesktopMainImages';
import { MobileHero } from './MobileHero';
interface HeaderInfoSectionProps {
  title: string;
  heroImageUrlList: string[];
  adultYN: boolean;
  institutionId: number;
  institutionLogoUrl: string;
  institutionName: string;
  productSaleStatus: GiftSaleStatus;
  productName: string;
  reviewRating?: number;
  reviewCount: number;
  productNumber: string;
  requiredDonationAmount: number;
  onlineProductYN: boolean;
  onlineProductDesc?: string;
  exchangeYN: boolean;
  productData?: GiftProductDetail;
  className?: string;
}
export const HeaderInfoSection = t0 => {
  const $ = _c(73);
  const {
    title,
    heroImageUrlList,
    adultYN,
    institutionId,
    institutionLogoUrl,
    institutionName,
    productSaleStatus,
    productName,
    reviewCount,
    reviewRating,
    productNumber,
    requiredDonationAmount,
    exchangeYN,
    onlineProductYN,
    onlineProductDesc,
    productData,
    className
  } = t0;
  const isDesktopViewport = useMediaQuery(BREAKPOINTS.DESKTOP, true);
  const {
    scrollToSectionWithTab
  } = useScrollToSection();
  const {
    selectedOptions
  } = useGiftOption();
  let t1;
  if ($[0] !== selectedOptions) {
    t1 = Array.from(selectedOptions.values()).reduce(_temp, 0);
    $[0] = selectedOptions;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const totalExtraProductPrice = t1;
  let t2;
  if ($[2] !== productData?.currentPrice || $[3] !== requiredDonationAmount || $[4] !== selectedOptions.size || $[5] !== totalExtraProductPrice) {
    t2 = selectedOptions.size > 0 ? calculateRequiredDonationAmount((productData?.currentPrice ?? 0) + totalExtraProductPrice) : requiredDonationAmount;
    $[2] = productData?.currentPrice;
    $[3] = requiredDonationAmount;
    $[4] = selectedOptions.size;
    $[5] = totalExtraProductPrice;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const selectedDonationAmount = t2;
  const isStoppedSale = productSaleStatus === GIFT_SALE_STATUS.STOPPED;
  let t3;
  if ($[7] !== className) {
    t3 = cn("grid grid-cols-2 gap-28", "tablet:grid-cols-1", "mobile:grid-cols-1", className);
    $[7] = className;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== adultYN || $[10] !== heroImageUrlList) {
    t4 = <MobileHero heroImageUrlList={heroImageUrlList} adultYN={adultYN} />;
    $[9] = adultYN;
    $[10] = heroImageUrlList;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== adultYN || $[13] !== heroImageUrlList || $[14] !== title) {
    t5 = <DesktopMainImages title={title} heroImageUrlList={heroImageUrlList} adultYN={adultYN} />;
    $[12] = adultYN;
    $[13] = heroImageUrlList;
    $[14] = title;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== institutionId || $[17] !== productData?.institutionSlugId) {
    t6 = DONATION_ROUTES.HOMETOWNS_DETAIL.pathname({
      id: productData?.institutionSlugId ?? institutionId
    });
    $[16] = institutionId;
    $[17] = productData?.institutionSlugId;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== institutionLogoUrl || $[20] !== institutionName) {
    t7 = <div className="relative size-28 shrink-0 overflow-hidden rounded-pill border border-Gray-300"><Image fill={true} src={institutionLogoUrl} alt={institutionName} className="object-cover object-center" loading="eager" sizes="28px" /></div>;
    $[19] = institutionLogoUrl;
    $[20] = institutionName;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== institutionName) {
    t8 = <p className="font-600 text-Gray-600 typo-body4">{institutionName}</p>;
    $[22] = institutionName;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <SvgChevronright className="size-16 text-Gray-600" />;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t6 || $[26] !== t7 || $[27] !== t8) {
    t10 = <CustomLink href={t6} className="flex items-center gap-4">{t7}{t8}{t9}</CustomLink>;
    $[25] = t6;
    $[26] = t7;
    $[27] = t8;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <ShareButton />;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== t10) {
    t12 = <div className="mb-8 flex items-center justify-between gap-4">{t10}{t11}</div>;
    $[30] = t10;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== isStoppedSale) {
    t13 = cn("flex-1 break-all font-700 text-Gray-900 typo-h3", "tablet:font-600 tablet:typo-body2", "mobile:font-600 mobile:typo-body2", {
      "text-Gray-400": isStoppedSale
    });
    $[32] = isStoppedSale;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] !== productName || $[35] !== t13) {
    t14 = <div className="mb-8 flex justify-between gap-16"><h1 className={t13}>{productName}</h1></div>;
    $[34] = productName;
    $[35] = t13;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  let t15;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = cn("mb-28 flex gap-8", "tablet:gap-4", "mobile:gap-4");
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  const t16 = reviewRating ?? 0;
  const t17 = isDesktopViewport ? 24 : 12;
  let t18;
  if ($[38] !== t16 || $[39] !== t17) {
    t18 = <Rating value={t16} size={t17} />;
    $[38] = t16;
    $[39] = t17;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] !== reviewCount || $[42] !== scrollToSectionWithTab) {
    t19 = reviewCount > 0 && <button type="button" onClick={() => scrollToSectionWithTab("review")} className={cn("font-600 text-Gray-600 underline typo-body3", "tablet:typo-caption1", "mobile:typo-caption1")}>{reviewCount.toLocaleString()}건 후기 보기</button>;
    $[41] = reviewCount;
    $[42] = scrollToSectionWithTab;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  let t20;
  if ($[44] !== t18 || $[45] !== t19) {
    t20 = <div className={t15}>{t18}{t19}</div>;
    $[44] = t18;
    $[45] = t19;
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  let t21;
  if ($[47] !== selectedDonationAmount) {
    t21 = <div className="mb-20 flex items-end justify-between"><PriceInfo amount={selectedDonationAmount} /></div>;
    $[47] = selectedDonationAmount;
    $[48] = t21;
  } else {
    t21 = $[48];
  }
  let t22;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = cn("flex flex-col gap-24 border-t border-Gray-200 py-20", "tablet:gap-16", "mobile:gap-16");
    $[49] = t22;
  } else {
    t22 = $[49];
  }
  let t23;
  if ($[50] !== onlineProductDesc || $[51] !== onlineProductYN) {
    t23 = onlineProductYN ? <div className={cn("flex flex-col gap-12 typo-body3", "tablet:typo-body4", "mobile:typo-body4")}><div className="flex items-start gap-16"><p className="w-92 shrink-0 font-400 text-Gray-600">배송정보</p><p className="font-700 text-Gray-700">온라인 답례품</p></div>{onlineProductDesc ? <div className="flex items-start gap-16"><p className="w-92 shrink-0 font-400 text-Gray-600">답례품 설명</p><p className="whitespace-pre-line font-700 text-Gray-700">{onlineProductDesc}</p></div> : null}</div> : <div className={cn("flex flex-col gap-12 typo-body3", "tablet:typo-body4", "mobile:typo-body4")}><div className="flex items-center gap-16"><p className="w-92 font-400 text-Gray-600">배송정보</p><p className="font-700 text-Gray-700">무료배송</p></div><div className="flex gap-16"><p className="w-92 shrink-0 font-400 text-Gray-600">배송안내</p><div className="flex flex-col gap-4"><p className="font-700 text-Gray-700">{DELIVERY_PERIOD_LABEL}</p></div></div></div>;
    $[50] = onlineProductDesc;
    $[51] = onlineProductYN;
    $[52] = t23;
  } else {
    t23 = $[52];
  }
  let t24;
  if ($[53] !== exchangeYN) {
    t24 = !exchangeYN && <div className="gap-8 rounded-xsmall bg-Gray-50 px-20 py-12 font-400 text-Gray-600 flex-center typo-caption1"><SvgWarningFill className="size-16 text-B-500" /><p>해당 답례품은 반품/교환이 불가능합니다.</p></div>;
    $[53] = exchangeYN;
    $[54] = t24;
  } else {
    t24 = $[54];
  }
  let t25;
  if ($[55] !== t23 || $[56] !== t24) {
    t25 = <div className={t22}>{t23}{t24}</div>;
    $[55] = t23;
    $[56] = t24;
    $[57] = t25;
  } else {
    t25 = $[57];
  }
  let t26;
  if ($[58] !== productData || $[59] !== productNumber) {
    t26 = <PrefillForm productData={productData} productNumber={productNumber} />;
    $[58] = productData;
    $[59] = productNumber;
    $[60] = t26;
  } else {
    t26 = $[60];
  }
  let t27;
  if ($[61] !== t12 || $[62] !== t14 || $[63] !== t20 || $[64] !== t21 || $[65] !== t25 || $[66] !== t26) {
    t27 = <div><section className="flex w-full flex-col px-20">{t12}{t14}{t20}{t21}{t25}{t26}</section></div>;
    $[61] = t12;
    $[62] = t14;
    $[63] = t20;
    $[64] = t21;
    $[65] = t25;
    $[66] = t26;
    $[67] = t27;
  } else {
    t27 = $[67];
  }
  let t28;
  if ($[68] !== t27 || $[69] !== t3 || $[70] !== t4 || $[71] !== t5) {
    t28 = <div className={t3}>{t4}{t5}{t27}</div>;
    $[68] = t27;
    $[69] = t3;
    $[70] = t4;
    $[71] = t5;
    $[72] = t28;
  } else {
    t28 = $[72];
  }
  return t28;
};
function _temp(total, option) {
  return total + option.extraProductPrice;
}